function env(name: string): string | undefined {
  const value = process.env[name];
  return value && value.trim() !== "" ? value : undefined;
}

export const URLS = {
  privacyPolicy:
    env("REACT_APP_PRIVACY_POLICY_URL") ??
    "https://www.ostgotatrafiken.se/kontakt-och-hjalp/villkor-och-regler/villkor-nar-du-reser-med-oss/hantering-av-personuppgifter",
  loginUrl:
    env("REACT_APP_LOGIN_URL") ??
    "https://white-water-0696e0303.2.azurestaticapps.net/#/",
  advantageMyAccount:
    env("REACT_APP_ADVANTAGE_MY_ACCOUNT_URL") ??
    "https://use-ostgotatrafiken.sitevision-cloud.se/res-med-oss/allt-om-resan/fordelar-med-mitt-konto",
};
